import { Component } from '../base/component';
import { ensureElement } from '../../utils/utils';
import { ITEM_CURRENCY, ITEM_NOCURRENCY, ITEM_CATEGORY, } from '../../utils/constants';
import { CDN_URL } from '../../utils/constants';
export class Product extends Component {
    constructor(container, events) {
        super(container);
        this._title = ensureElement('.card__title', container);
        this._price = ensureElement('.card__price', container);
        this._description = container.querySelector('.card__text');
        this._category = container.querySelector('.card__category');
        this._image = container.querySelector('.card__image');
        this._productButton = container.querySelector('.card__button');
        if (events && this._productButton) {
            this._productButton.addEventListener('click', events.onClick);
        }
        else if (events && !this._productButton) {
            this.container.addEventListener('click', events.onClick);
        }
    }
    set id(value) {
        this._id = value;
    }
    get id() {
        return this._id || '';
    }
    set title(value) {
        this.setText(this._title, value);
    }
    get title() {
        return this._title.textContent || '';
    }
    set image(value) {
        var _a;
        (_a = this._image) === null || _a === void 0 ? void 0 : _a.setAttribute('src', `${CDN_URL}${value}`);
    }
    set description(value) {
        if (this._description) {
            this.setText(this._description, value);
        }
    }
    set price(value) {
        if (value) {
            this.setText(this._price, `${value} ${ITEM_CURRENCY}`);
        }
        else {
            this.setText(this._price, `${ITEM_NOCURRENCY}`);
            this.setDisabled(this._productButton, true);
        }
    }
    set category(value) {
        if (this._category) {
            this.setText(this._category, value);
            this.toggleClass(this._category, `card__category_${ITEM_CATEGORY[value]}`, true);
        }
    }
    set inCart(value) {
        if (value) {
            this.setText(this._productButton, 'Убрать');
        }
        else {
            this.setText(this._productButton, 'В корзину');
        }
    }
}
